
import { NavigationItem } from "../types";
import { LayoutDashboard, CreditCard, CheckSquare, Home, TrendingUp, Building, FileText, MessageSquare, Settings, FileCheck } from "lucide-react";

export const borrowerNavigation: NavigationItem[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    name: "Dashboard",
    icon: LayoutDashboard,
    href: "/borrower/dashboard",
  },
  {
    id: "loans",
    title: "Loans",
    name: "Loans",
    icon: CreditCard,
    href: "/borrower/loans",
  },
  {
    id: "pre-approval",
    title: "Pre-Approval",
    name: "Pre-Approval",
    icon: CheckSquare,
    href: "/borrower/pre-approval",
  },
  {
    id: "properties",
    title: "My Properties",
    name: "My Properties",
    icon: Home,
    href: "/borrower/properties",
  },
  {
    id: "investments",
    title: "Investments",
    name: "Investments",
    icon: TrendingUp,
    href: "/borrower/investments",
  },
  {
    id: "real-estate",
    title: "Buy Properties",
    name: "Buy Properties",
    icon: Building,
    href: "/real-estate",
  },
  {
    id: "lenders",
    title: "Lenders",
    name: "Lenders",
    icon: Building,
    href: "/borrower/lenders",
  },
  {
    id: "documents",
    title: "Documents",
    name: "Documents",
    icon: FileText,
    href: "/borrower/documents",
  },
  {
    id: "messages",
    title: "Messages",
    name: "Messages",
    icon: MessageSquare,
    href: "/borrower/messages",
  },
  {
    id: "settings",
    title: "Settings",
    name: "Settings",
    icon: Settings,
    href: "/borrower/settings",
  },
];
